module.exports = __webpack_public_path__ + "static/media/link3.66d95938.svg";